export default __webpack_public_path__ + "55b5ebe79e9135f86170a1362c7a2a2b.svg";